export const GET_JOB_LIST_FAIL = "GET_JOB_LIST_FAIL";
export const GET_JOB_LIST_REQUEST = "GET_JOB_LIST_REQUEST";
export const GET_JOB_LIST_SUCCESS = "GET_JOB_LIST_SUCCESS";

export const CREATE_JOB_LIST_FAIL = "CREATE_JOB_LIST_FAIL";
export const CREATE_JOB_LIST_REQUEST = "CREATE_JOB_LIST_REQUEST";
export const CREATE_JOB_LIST_SUCCESS = "CREATE_JOB_LIST_SUCCESS";

export const GET_SKILL_LIST_FAIL = "GET_SKILL_LIST_FAIL";
export const GET_SKILL_LIST_REQUEST = "GET_SKILL_LIST_REQUEST";
export const GET_SKILL_LIST_SUCCESS = "GET_SKILL_LIST_SUCCESS";

export const GET_APPLICANT_LIST_FAIL = "GET_APPLICANT_LIST_FAIL";
export const GET_APPLICANT_LIST_REQUEST = "GET_APPLICANT_LIST_REQUEST";
export const GET_APPLICANT_LIST_SUCCESS = "GET_APPLICANT_LIST_SUCCESS";

export const GET_JOB_DETAIL_FAIL = "GET_JOB_DETAIL_FAIL";
export const GET_JOB_DETAIL_REQUEST = "GET_JOB_DETAIL_REQUEST";
export const GET_JOB_DETAIL_SUCCESS = "GET_JOB_DETAIL_SUCCESS";